import { motion } from 'framer-motion'
import { withTranslation } from 'react-i18next'

import Button from '@/ui/Button'
import LazyImage from '@/ui/LazyImage'

import { MenuItemImage, MenuItemPrice, MenuItemTitle, MenuItemWrapper } from './MenuItem.styles'

const MenuItem = ({ t, price, name, imageUrl, onClick }) => {
  return (
    <MenuItemWrapper
      onClick={onClick}
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.1 }}
    >
      <MenuItemImage>
        <LazyImage src={imageUrl} />
      </MenuItemImage>
      <MenuItemTitle>{name}</MenuItemTitle>
      <MenuItemPrice>
        {price?.amount.toFixed(2)} {price?.currency}
      </MenuItemPrice>
      <Button size="sm" onClick={onClick}>
        {t('select')}
      </Button>
    </MenuItemWrapper>
  )
}

export default withTranslation()(MenuItem)
